import EskStrategicHomepage from './components/EskStrategicHomepage';

function App() {
  return <EskStrategicHomepage />;
}

export default App;